import { render, staticRenderFns } from "./faceCollectApproval.vue?vue&type=template&id=0c6a8ab1&scoped=true&"
import script from "./faceCollectApproval.vue?vue&type=script&lang=js&"
export * from "./faceCollectApproval.vue?vue&type=script&lang=js&"
import style0 from "./faceCollectApproval.vue?vue&type=style&index=0&id=0c6a8ab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a8ab1",
  null
  
)

export default component.exports